import { Input } from "@aidkitorg/component-library";
import { useCallback } from "react";
import { useLocalizedStrings } from "../../../../Localization";
import { FilterWrapper } from "./FilterWrapper";

interface IssueDateFilterProps {
  startDate: string;
  endDate: string;
  onStartDateChange: (date: string) => void;
  onEndDateChange: (date: string) => void;
}

export const IssueDateFilter: React.FC<IssueDateFilterProps> = ({
  startDate,
  endDate,
  onStartDateChange,
  onEndDateChange,
}) => {
  const L = useLocalizedStrings();
  
  const handleStartDateChange = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    onStartDateChange(e.target.value);
  }, [onStartDateChange]);

  const handleEndDateChange = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    onEndDateChange(e.target.value);
  }, [onEndDateChange]);

  return (
    <FilterWrapper label={L.admin_panel.invoices.filters.issue_date}>
      <div className="flex flex-col gap-1.5 items-start pt-1.5 sm:flex-row sm:items-center">
        <div className="flex-1">
          <Input
            type="date"
            value={startDate}
            onChange={handleStartDateChange}
            label={L.admin_panel.invoices.filters.from}
            showLabel={false}
          />
        </div>
        <div className="text-sm">{L.admin_panel.invoices.filters.to}</div>
        <div className="flex-1">
          <Input
            type="date"
            value={endDate}
            onChange={handleEndDateChange}
            label={L.admin_panel.invoices.filters.to}
            showLabel={false}
          />
        </div>
      </div>
    </FilterWrapper>
  );
};
